export const fr = {
  createOpportunityPage: {
    title: 'Créer votre propre opportunité de bénévolat',
    title_duplicate: "Dupliquer l'événement de bénévolat",
    form: {
      steps: {
        general: {
          title: 'Informations générales',
          subtitle: 'Commençons par les bases',
        },
        details: {
          title: 'Détails',
          subtitle: 'Maintenant les détails',
        },
        confirmation: {
          title: 'Confirmation',
          subtitle: 'Est-ce que tout est correct ?',
        },
        complete: {
          title: 'Confirmation',
          subtitle: 'Opportunité de bénévolat créée !',
        },
      },
      validations: {
        required: 'Requis.',
        timeError: "L'heure de début doit être avant l'heure de fin.",
        fixErrors: 'Veuillez corriger les erreurs ci-dessus pour continuer.',
        shiftsError: "Vous avez besoin d'au moins 2 quarts de travail pour créer un événement avec des quarts.",
        emailError: 'Veuillez entrer une adresse courriel valide.',
      },
      buttons: {
        back: 'Retour',
        saveAndContinue: 'Enregistrer et continuer',
        submitAndCreate: "Publier l'événement",
        publishChanges: 'Publier les modifications',
      },
    },
    fields: {
      name: {
        label: 'Nom',
        placeholder: "Entrez le nom de l'opportunité",
      },
      locationType: {
        label: 'Type de lieu',
        options: {
          inPerson: 'en personne',
          virtual: 'virtuel',
        },
      },
      hideListing: {
        label: "Masquer l'annonce",
      },
      date: {
        label: 'Date',
      },
      startTime: {
        label: 'Heure de début',
      },
      endTime: {
        label: 'Heure de fin',
      },
      timeZone: {
        label: 'Fuseau horaire',
      },
      location: {
        label: 'Lieu',
      },
      memberCapacity: {
        label: 'Capacité de membres',
      },
      nonprofitName: {
        label: "Nom de l'organisme",
      },
      description: {
        label: 'Description',
      },
      richTextSection: {
        label: 'Section de texte enrichi',
      },
      banner: {
        label: 'Bannière',
      },
      confirm: {
        label: 'Confirmer',
      },
    },
    warnings: {
      unsavedChanges: {
        title: 'Vous avez des modifications non enregistrées',
        message:
          'Êtes-vous sûr de vouloir quitter ? Toutes les modifications non enregistrées seront perdues.',
      },
    },
    basicDetails: {
      title: 'Commençons par les bases',
      nonprofitSection: {
        title: "Informations sur l'organisme",
      },
      fields: {
        name: {
          label: 'Nom de l’événement',
          placeholder: 'Nom',
        },
        groupType: {
          label: 'Type de groupe',
          tooltip:
            "Équipe est pour faire du bénévolat avec votre département ou vos amis. C'est idéal si vous avez un groupe ou une équipe spécifique en tête. Ces événements n'apparaîtront pas sur la page d'accueil mais vous pouvez les partager en partageant l'URL de l'événement.\n\nTout le monde est ouvert à toute personne de l'entreprise et fonctionne selon le principe du premier arrivé, premier servi. Parfait pour les bureaux où tous les employés peuvent s'impliquer.",
          options: {
            team: 'Équipe',
            anyone: 'Tout le monde',
            teamHint: "Limité aux membres d'une équipe spécifiée",
            anyoneHint:
              "Ouvert à toute personne de l'entreprise, premier arrivé, premier servi",
          },
        },
        locationType: {
          label: 'Type de lieu',
          options: {
            inPerson: 'En personne',
            virtual: 'Virtuel',
          },
        },
        timezone: {
          label: 'Fuseau horaire',
          placeholder: 'Sélectionnez un fuseau horaire',
          change: 'Changer le fuseau horaire de',
          hide: 'Masquer',
        },
        date: {
          label: 'Date',
          recommendations: '(recommandé : {{duration}})',
        },
        startTime: {
          label: 'Début',
        },
        endTime: {
          label: 'Fin',
        },
        location: {
          label: 'Adresse',
        },
        attendees: {
          label: 'Participants',
          placeholder: '# 10',
          hint: "Veuillez noter que ces événements sont prévus pour 2 personnes ou plus. Si vous réalisez un événement en solo, vous pouvez enregistrer vos heures de bénévolat sur la page <0>Mon bénévolat</0> après l'événement !",
          recommendations: '(recommandé : {{min}} - {{max}} participants)',
        },
        memberCapacity: {
          label: 'Participants',
          placeholder: '# 10',
        },
        eventLink: {
          label:
            "Lien de l'événement (peut être ajouté plus tard si le lien n'est pas encore disponible)",
          placeholder: "Lien de l'événement",
          tooltip:
            "Ajoutez un lien de réunion (ex. Teams, Meet, Zoom, etc.) pour cet événement afin que votre équipe puisse le compléter ensemble. Ce lien apparaîtra directement sur la page de l'événement. Vous pouvez également ajouter ce lien plus tard s'il n'est pas encore disponible.",
          hint: 'Le lien doit commencer par https://',
        },
        causes: {
          label: 'Causes (sélectionnez max. 3)',
          placeholder: 'Sélectionnez des causes',
        },
        nonprofitName: {
          label: "Nom de l'organisme",
          placeholder: 'ex. Quest Food Exchange',
        },
        nonprofitUrl: {
          label: 'URL du site web (optionnel)',
          placeholder: 'ex. https://purposely.co',
        },
        nonprofitContactName: {
          label: "Nom du contact de l'organisme (optionnel)",
          placeholder: 'ex. Jean Dupont',
        },
        nonprofitContactEmail: {
          label: "Courriel du contact de l'organisme",
          placeholder: 'ex. jean@organisme.org',
        },
        nonprofitContactPhone: {
          label: "Téléphone du contact de l'organisme (optionnel)",
          placeholder: 'ex. (604) 555-1234',
        },
        communityActionType: {
          label: "Type D'Action Communautaire",
          designated: 'Organisme désigné',
          designatedDescription: "Vous choisissez l'organisme maintenant. Tout le monde fait du bénévolat ensemble au même endroit.",
          designatedPill: "Organisme défini à la création",
          designatedDetail: "Idéal pour les événements de groupe, les journées d'équipe ou lorsque vous avez un organisme partenaire spécifique en tête.",
          openNonprofit: 'Organisme ouvert',
          openNonprofitDescription: "Les employés font du bénévolat localement où ils le souhaitent. Ils indiquent l'organisme lors de la soumission de leurs heures.",
          openNonprofitPill: 'Organisme indiqué à la soumission',
          openNonprofitDetail: "Idéal pour les équipes mondiales ou les campagnes où les employés font du bénévolat dans leurs propres organismes locaux.",
        },
      },
    },
    review: {
      title: 'Est-ce que tout est correct ?',
      subtitle:
        "Jetez un coup d'œil à l'aperçu de votre opportunité de bénévolat à droite et confirmez que tous les détails sont corrects. Vous pourrez toujours revenir et modifier l'opportunité après l'avoir créée !",
      confirmations: {
        organized:
          "Je confirme que j'ai organisé cet événement et que l'organisme est au courant de notre participation",
        organizedVirtual:
          "Je confirme avoir lu toutes les instructions qui se trouvent sur la page de l'événement virtuel",
        join: "(Optionnel) Cochez cette case pour rejoindre l'opportunité après sa création",
      },
    },
    preview: {
      emptyState: {
        title:
          "Ajoutez des détails pour voir votre page d'événement prendre vie !",
        description:
          'Commencez à remplir les détails de votre opportunité de bénévolat et obtenez un aperçu de son apparence une fois en ligne.',
      },
      buttons: {
        visitWebsite: 'Visiter le site',
      },
      location: {
        virtual: 'Événement virtuel',
        selfDirected: 'Partout',
        meetAt: 'Rendez-vous à',
      },
    },
    nextSteps: {
      title: 'Évènement bénévole créé !',
      titleEdit: 'Évènement bénévole modifié !',
      titleOngoing: 'Action communautaire créée !',
      titleEditOngoing: 'Action communautaire modifiée !',
      subtitleWithLink:
        "Merci d'organiser cet événement ! Vous pouvez voir ou modifier votre événement dans l'onglet <0>Mes demandes & événements créés</0>",
      subtitleWithLinkOngoing:
        "Merci d'organiser cette action ! Vous pouvez voir ou modifier votre action dans l'onglet <0>Mes demandes & événements créés</0>",
      steps: {
        title: 'Prochaines étapes',
        subtitle:
          'Voici quelques étapes que vous pouvez suivre pour faire passer le mot.',
        subtitleOngoing:
          'Voici quelques étapes que vous pouvez suivre pour faire passer le mot.',
        list: {
          invite: 'Inviter vos collègues',
          share: 'Partager cette opportunité dans Teams/Slack',
        },
      },
      stepsPast: {
        subtitle: "Personnalisez davantage votre événement avec ces prochaines étapes.",
        subtitleOngoing: "Personnalisez davantage votre action avec ces prochaines étapes.",
        list: {
          addVolunteers: 'Ajouter vos collègues',
          addPhotos: 'Ajouter des photos de votre événement',
          addPhotosOngoing: 'Ajouter des photos de votre action',
        },
      },
      buttons: {
        viewOpportunity: "Voir l'événement",
        viewOpportunityOngoing: "Voir l'action",
      },
    },
    confirmation: {
      title: 'Maintenant pour plus de détails',
      fields: {
        description: {
          label: `Description pour la carte de l'événement`,
          placeholder: 'Description',
          tooltip: `Ceci est une brève description qui apparaîtra sur la carte de l'événement dans les listes avec d'autres événements`,
        },
        banner: {
          title: 'Image de bannière',
          subtitle: 'Choisissez parmi notre liste ou téléchargez la vôtre',
          drawer: {
            header: 'Images par défaut',
            subheader: 'Développer pour voir les images',
          },
        },
      },
      dividers: {
        or: 'ou',
      },
    },
    warningModal: {
      title: 'Quitter cette page ?',
      message:
        "Vous avez des modifications non enregistrées, êtes-vous sûr de vouloir partir ? Vous pouvez toujours aller dans l'onglet Créé de Mes événements pour modifier et publier les brouillons enregistrés.",
      buttons: {
        stay: 'Rester',
        leave: 'Quitter',
      },
    },
  },
}
